import { NavLink } from 'react-router-dom'

/** Admin chrome (01 §5). Staff-only; `RequireStaff role="admin"` gates the routes. */
const TABS = [
  { to: '/admin', label: 'Overview', end: true },
  { to: '/admin/products', label: 'Products' },
  { to: '/admin/stores', label: 'Stores' },
  { to: '/admin/labor', label: 'Labour rates' },
  { to: '/admin/sessions', label: 'Sessions' },
]

export function AdminLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto w-full max-w-[1280px] overflow-x-clip px-5 py-8">
      <p className="eyebrow">Admin</p>
      <nav
        aria-label="Admin sections"
        className="-mx-5 mt-4 flex gap-2 overflow-x-auto px-5 pb-1 sm:mx-0 sm:px-0"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `min-h-11 shrink-0 rounded-pill border px-4 text-sm font-semibold leading-[2.4] transition-colors ${
                isActive
                  ? 'border-navy bg-navy text-white'
                  : 'border-line bg-white text-ink hover:border-blue'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-6">{children}</div>
    </div>
  )
}
